import { useQuery } from "@tanstack/react-query";
import { fetchVcasStatusOptions } from "../../../api/workPacketsAPI";
import { EMPTY_ARRAY } from "src/utils/empty-values";
import { WorkPacketType } from "src/pages/UserDashboard/WorkPackets/WorkPacketType";

export const useVcasStatusOptions = () => {
  const query = useQuery({
    queryFn: fetchVcasStatusOptions,
    queryKey: ["work-packets", WorkPacketType.SHORTAGES, "vcas-status-options"],
    staleTime: 30000,
  });

  return query.data ?? EMPTY_ARRAY;
};
